module.exports = __webpack_public_path__ + "static/media/ianrod-eireann.5ae28ea1.png";